import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-02dc4530"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "svg-icon",
  "area-hidden": "true"
};
const _hoisted_2 = ["xlink:href"];
import { computed } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    icon: {
      type: String,
      required: true
    },
    size: {
      type: [Number, String],
      default: 16
    }
  },
  setup(__props) {
    _useCssVars(_ctx => ({
      "6cd71f2f": iconSize.value
    }));
    const props = __props;
    const iconName = computed(() => {
      return `#icon-${props.icon}`;
    });
    const iconSize = computed(() => {
      return props.size + 'px';
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("svg", _hoisted_1, [_createElementVNode("use", {
        "xlink:href": iconName.value
      }, null, 8, _hoisted_2)]);
    };
  }
});